import {FaCircleNodes, FaMagnifyingGlassChart, FaShield} from "react-icons/fa6";
import {
  FaAddressBook,
  FaCar,
  FaClone, FaCode,
  FaFileAlt,
  FaPaperPlane,
  FaSkullCrossbones,
  FaUser,
  FaVideo
} from "react-icons/fa";
import {PermissionEnum} from "../../../utils/enums/permission-enum.js";

const SentryMenu = {
    "staticMenu": [
        {
            "app": false,
            "appName": null,
            "name": "Central de Atendimento e Despacho",
            "icon": "sw-dispatch",
            "image": true,
            "permissions": [PermissionEnum.DISPATCH],
            "url": "despacho/dashboard",
            "id": "dispatch"
        },
        {
            "app": false,
            "appName": null,
            "name": "BOGCM",
            "icon": "sw-bogcm",
            "image": true,
            "permissions": [PermissionEnum.BOGCM_WEB],
            "url": "bos",
            "id": "bo"
        },
        {
            "app": true,
            "appName": "sentryview",
            "name": "Sentry View",
            "icon": "sw-view",
            "image": true,
            "permissions": "",
            "url": "sentryview/access",
            "id": "card-view",
            "description": "Sentry view"
        },
        {
            "app": false,
            "appName": null,
            "name": "Análise georreferenciada",
            "icon": "sw-geoanalysis",
            "image": true,
            "permissions": [PermissionEnum.GEOREF],
            "url": "analysis-tool",
            "description": "Análise georreferenciada",
            "id": "analysisTool"
        },
        {
            "app": false,
            "appName": null,
            "name": "Mapa em tempo real",
            "icon": "sw-timereal",
            "image": true,
            "permissions": [PermissionEnum.GIS],
            "url": "gis",
            "id": "gis",
            "description": "Mapa em tempo real"
        },
        {
            "app": false,
            "appName": null,
            "name": "Monitoramento patrimonial",
            "icon": "sw-patrimonial",
            "image": true,
            "permissions": [PermissionEnum.CONTACTID],
            "url": "contact-id",
            "id": "contactid",
            "description": "Centrais de alarme"
        },
        {
            "app": false,
            "appName": null,
            "name": "Abordagem",
            "icon": "sw-approach",
            "image": true,
            "permissions": [PermissionEnum.ENCOUNTER],
            "url": "encounter",
            "id": "encounter"
        },
        {
            "app": false,
            "appName": null,
            "name": "Guichê",
            "icon": "fa-solid fa-arrow-right-arrow-left",
            "permissions": [PermissionEnum.ERP_MATERIALS_RESPONSIBLE],
            "id": "home-material-movements",
            "url": "materials/movements"
        },
        {
            "app": false,
            "appName": null,
            "name": "Downloads",
            "permissions": "",
            "image": false,
            "icon": "fa-solid fa-download",
            "url": "download",
            "id": "download"
        },
        {
            "app": false,
            "appName": null,
            "name": "Biblioteca",
            "permissions": "",
            "image": true,
            "icon": "sw-library",
            "url": "library",
            "id": "library"
        },
        {
            "app": false,
            "appName": null,
            "name": "SOS Cidadão",
            "icon": "sw-sos",
            "image": true,
            "permissions": "sentry.sos.manage.*, sentry.sos.view.*",
            "id": "sos-home-menu",
            "url": "sos/home"
        },
        {
            "app": false,
            "appName": false,
            "name": "Dashboard Muralha",
            "icon": "sw-dashwall",
            "image": true,
            "permissions": [PermissionEnum.DASHBOARD_WALL],
            "id": "dashboard-wall",
            "url": "sentry-wall",
            "hideMenu": true
        },
    ],
    "menu": [
        {
            "name": "Cards",
            "permissions": "",
            "icon": "icon-sw-card",
            "id": "home-geral",
            "url": "home",
            "items": [
                {
                    "name": "Home",
                    "permissions": "",
                    "url": "home",
                    "id": "home"
                },
                {
                    "name": "CAD",
                    "permissions": [PermissionEnum.DISPATCH],
                    "url": "despacho/dashboard",
                    "id": "dashboard",
                    "hideMenu": true
                },
                {
                    "name": "BOGCM",
                    "permissions": [PermissionEnum.BOGCM_WEB],
                    "url": "bos",
                    "activeUrls": ["bo"],
                    "id": "bo"
                },
                {
                    "name": "Análise georreferenciada",
                    "permissions": [PermissionEnum.GEOREF],
                    "url": "analysis-tool",
                    "id": "analysisTool",
                    "hideMenu": true
                },
                {
                    "name": "Mapa em tempo real",
                    "permissions": [PermissionEnum.GIS],
                    "url": "gis",
                    "id": "gis",
                    "hideMenu": true
                },
                {
                    "name": "Monitoramento patrimonial",
                    "permissions": [PermissionEnum.CONTACTID],
                    "url": "contact-id",
                    "id": "patrimonial"
                },
                {
                    "name": "Abordagem",
                    "permissions": [PermissionEnum.ENCOUNTER],
                    "url": "encounter",
                    "id": "encounter"
                },
                {
                    "name": "Downloads",
                    "permissions": "",
                    "url": "download",
                    "id": "download"
                },
                {
                    "name": "Guichê",
                    "permissions": [PermissionEnum.ERP_MATERIALS_RESPONSIBLE],
                    "url": "materials/movements",
                    "description": "",
                    "id": "cards-material-movements"
                },
                {
                    "name": "SOS Cidadão",
                    "permissions": "sentry.sos.manage.*, sentry.sos.view.*",
                    "id": "sos-home-menu",
                    "url": "sos/home",
                    "hideMenu": true
                },
                {
                    "name": "Biblioteca",
                    "permissions": "sentry.*",
                    "url": "library",
                    "id": "library"
                },
                {
                    "name": "Dashboard Muralha",
                    "permissions": [PermissionEnum.DASHBOARD_WALL],
                    "url": "sentry-wall",
                    "id": "dashboard-wall",
                    "hideMenu": true,
                },
            ]
        },
        {
            "name": "Administração",
            "id": "admin",
            "permissions": [PermissionEnum.MOBILE_ALARM_RULES_ADMIN, PermissionEnum.CAPTURE_PLACE, PermissionEnum.USER, PermissionEnum.ADDRESSES_ADMIN, PermissionEnum.GEOREF_ADMIN, PermissionEnum.CONFIGURATION, PermissionEnum.CONTACTID_ADMIN, PermissionEnum.SENTRY_CLOUD, PermissionEnum.ALARM_CONFIGURATIONS, PermissionEnum.ALARM_INACTIVATE, PermissionEnum.VIDEO_CAMERA, PermissionEnum.STANDARD_OPERATING_PROCEDURES, PermissionEnum.LIBRARY_MANAGE, PermissionEnum.BOGCM_TAGS, PermissionEnum.SENTRY_PHONE_CONFIG, PermissionEnum.SENTRY_PHONE_CALL_LOG],
            "icon": FaShield,
            "url": "#",
            "items": [
                {
                    "name": "Aplicativos móveis",
                    "permissions": [PermissionEnum.MOBILE_ALARM_RULES_ADMIN],
                    "id": "apps",
                    "url": "#",
                    "items": [
                        {
                            "name": "Dispositivos",
                            "permissions": [PermissionEnum.MOBILE_ALARM_RULES_ADMIN],
                            "url": "device",
                            "id": "device"
                        },
                        {
                            "name": "Regras de alarme",
                            "permissions": [PermissionEnum.MOBILE_ALARM_RULES_ADMIN],
                            "url": "rule",
                            "activeUrls": ["rule-form"],
                            "id": "rule"
                        }
                    ]
                },
                {
                    "name": "Alarmes",
                    "permissions": [PermissionEnum.ALARM_CONFIGURATIONS, PermissionEnum.ALARM_INACTIVATE],
                    "id": "alarms",
                    "url": "#",
                    "items": [
                        {
                            "name": "Perguntas de alarmes",
                            "permissions": [PermissionEnum.ALARM_CONFIGURATIONS],
                            "url": "alarm-question",
                            "id": "alarmQuestion"
                        },
                        {
                            "name": "Assinatura automática",
                            "permissions": [PermissionEnum.ALARM_CONFIGURATIONS, PermissionEnum.ALARM_INACTIVATE],
                            "url": "auto-assign",
                            "id": "userAutoAssign"
                        },
                        {
                            "name": "Parâmetros",
                            "permissions": [PermissionEnum.ALARM_CONFIGURATIONS],
                            "url": "alarm-parameters",
                            "id": "alarmParameters"
                        }
                    ]
                },
                {
                    "name": "Câmeras de OCR",
                    "permissions": [PermissionEnum.CAPTURE_PLACE],
                    "id": "groupCameras",
                    "url": "#",
                    "items": [
                        {
                            "name": "Câmeras",
                            "permissions": [PermissionEnum.CAPTURE_PLACE],
                            "url": "lanes",
                            "id": "lanes"
                        },
                        {
                            "name": "Pontos de coleta",
                            "permissions": [PermissionEnum.CAPTURE_PLACE],
                            "url": "capture-places",
                            "id": "capture-places"
                        },
                        {
                            "name": "Sentidos",
                            "permissions": [PermissionEnum.CAPTURE_PLACE],
                            "url": "route",
                            "id": "route"
                        },
                        {
                            "name": "Integrações",
                            "permissions": [PermissionEnum.CAPTURE_PLACE],
                            "url": "integrations",
                            "id": "integrations"
                        },
                        {
                            "name": "Resp. por manutenção",
                            "permissions": [PermissionEnum.CAPTURE_PLACE],
                            "url": "responsible-maintenance",
                            "id": "responsible-maintenance"
                        },
                        {
                            "name": "Grupos de seleção de câmeras (SentryView)",
                            "permissions": [PermissionEnum.CAPTURE_PLACE],
                            "url": "lane-alias",
                            "id": "lane-alias"
                        }
                    ]
                },
                {
                    "name": "Câmeras de vídeo",
                    "permissions": [PermissionEnum.VIDEO_CAMERA],
                    "id": "cameras",
                    "url": "#",
                    "items": [
                        {
                            "name": "Câmeras",
                            "permissions": [PermissionEnum.VIDEO_CAMERA],
                            "id": "video-cameras",
                            "url": "video-cameras",
                            "homeName": "Câmeras de vídeo"
                        },
                        {
                            "name": "Gravadores",
                            "permissions": [PermissionEnum.VIDEO_CAMERA],
                            "id": "recorders",
                            "url": "recorders"
                        }
                    ]
                },
                {
                    "name": "Operacional",
                    "permissions": [PermissionEnum.CONFIGURATION, PermissionEnum.STANDARD_OPERATING_PROCEDURES],
                    "id": "general-operational",
                    "url": "#",
                    "items": [
                        {
                            "name": "Condições",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "conditions",
                            "id": "conditions-form"
                        },
                        {
                            "name": "Encaminhamentos",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "referrals",
                            "id": "referrals-form"
                        },
                        {
                            "name": "Naturezas de ocorrências",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "nature",
                            "id": "nature"
                        },
                        {
                            "name": "Objetos",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "objects",
                            "id": "configObject"
                        },
                        {
                            "name": "Organizações",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "ecap-organization",
                            "id": "ecap-organization"
                        },
                        {
                            "name": "Tipos de documentos",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "otherDocumentTypes",
                            "id": "otherDocumentType"
                        },
                        {
                            "name": "Motivos de ausência",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "absence-types",
                            "id": "absence-types"
                        }
                    ]
                },
                {
                    "name": "Sistema",
                    "permissions": [PermissionEnum.CONFIGURATION],
                    "id": "general-system",
                    "url": "#",
                    "items": [
                        {
                            "name": "Backup",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "backup",
                            "id": "backup"
                        },
                        {
                            "name": "Compressão de imagens",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "compression",
                            "id": "compression"
                        },
                        {
                            "name": "Corporação",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "corporation",
                            "id": "corporation"
                        },
                        {
                            "name": "Licenciamento",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "licensing",
                            "id": "licensing"
                        },
                        {
                            "name": "Status de armazenamento",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "storage-status",
                            "id": "storageStatus"
                        },
                        {
                            "name": "Usuários logados",
                            "permissions": [PermissionEnum.CONFIGURATION],
                            "url": "sessions",
                            "id": "sessions",
                            "hideMenu": true
                        }
                    ]
                },
                {
                    "name": "Controle de acesso",
                    "permissions": [PermissionEnum.USER],
                    "id": "acessControl",
                    "url": "#",
                    "items": [
                        {
                            "name": "Agentes",
                            "permissions": [PermissionEnum.USER],
                            "url": "user-agents",
                            "id": "user-agents"
                        },
                        {
                            "name": "Funções",
                            "permissions": [PermissionEnum.USER],
                            "url": "role",
                            "id": "role"
                        },
                        {
                            "name": "Grupos de operação",
                            "permissions": [PermissionEnum.USER],
                            "url": "group",
                            "id": "group"
                        }
                    ]
                },
                {
                    "name": "Endereços",
                    "permissions": [PermissionEnum.ADDRESSES_ADMIN],
                    "id": "adresses",
                    "url": "#",
                    "items": [
                        {
                            "name": "Bairros",
                            "permissions": [PermissionEnum.ADDRESSES_ADMIN],
                            "url": "neighborhood",
                            "id": "neighborhood"
                        },
                        {
                            "name": "Locais pré-cadastrados",
                            "permissions": [PermissionEnum.ADDRESSES_ADMIN],
                            "url": "place",
                            "id": "place"
                        },
                        {
                            "name": "Logradouros",
                            "permissions": [PermissionEnum.ADDRESSES_ADMIN],
                            "url": "street",
                            "id": "street"
                        },
                        {
                            "name": "Tipos de local",
                            "permissions": [PermissionEnum.ADDRESSES_ADMIN],
                            "url": "typePlace",
                            "id": "typePlace"
                        }
                    ]
                },
                {
                    "name": "Georreferenciamento",
                    "permissions": [PermissionEnum.GEOREF_ADMIN],
                    "url": "#",
                    "id": "georef",
                    "items": [
                        {
                            "name": "Pontos",
                            "permissions": [PermissionEnum.GEOREF_ADMIN],
                            "url": "point-layer",
                            "id": "pointLayer"
                        },
                        {
                            "name": "Setores",
                            "permissions": [PermissionEnum.GEOREF_ADMIN],
                            "url": "area-layer",
                            "id": "areaLayer"
                        }
                    ]
                },
                {
                    "name": "SentryCloud",
                    "permissions": [PermissionEnum.SENTRY_CLOUD],
                    "id": "sentryCloudGroup",
                    "url": "#",
                    "items": [
                        {
                            "name": "Configurações de clone",
                            "permissions": [PermissionEnum.SENTRY_CLOUD],
                            "url": "sentry-cloud",
                            "id": "sentryCloud"
                        },
                        {
                            "name": "Regra de monitoramento automático",
                            "permissions": [PermissionEnum.SENTRY_CLOUD],
                            "url": "acceptance-rules",
                            "id": "acceptance-rules"
                        }
                    ]
                },
                {
                    "name": "Monitoramento patrimonial",
                    "permissions": [PermissionEnum.CONTACTID_ADMIN],
                    "id": "contactIdGroup",
                    "url": "#",
                    "items": [
                        {
                            "name": "Cadastro",
                            "permissions": [PermissionEnum.CONTACTID_ADMIN],
                            "url": "contact-id",
                            "id": "contactid"
                        },
                        {
                            "name": "Tipos de eventos",
                            "permissions": [PermissionEnum.CONTACTID_ADMIN],
                            "url": "contact-id-event-types",
                            "id": "contactid-event-types"
                        }
                    ]
                },
                {
                    "name": "Sentry Phone",
                    "permissions": [PermissionEnum.SENTRY_PHONE_CONFIG, PermissionEnum.SENTRY_PHONE_CALL_LOG],
                    "id": "sentryPhone",
                    "url": "#",
                    "items": [
                        {
                            "name": "Configurações",
                            "permissions": [PermissionEnum.SENTRY_PHONE_CONFIG],
                            "url": "sentry-phone-settings",
                            "id": "sentry-phone-settings"
                        },
                        {
                            "name": "Registros de chamadas",
                            "permissions": [PermissionEnum.SENTRY_PHONE_CALL_LOG],
                            "url": "sentry-phone-calls",
                            "id": "sentry-phone-calls"
                        }
                    ]
                },
                {
                    "name": "CAD",
                    "permissions": [PermissionEnum.BOGCM_TAGS],
                    "id": "cad",
                    "url": "#",
                    "items": [
                        {
                            "name": `Marcadores de BOGCM`,
                            "permissions": [PermissionEnum.BOGCM_TAGS],
                            "url": "bos-tags",
                            "id": "bos-tags"
                        },
                    ]
                },
            ]
        },
        {
            "name": "Gestão",
            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE2, PermissionEnum.ERP_PERSONAL, PermissionEnum.ERP_ASSET, PermissionEnum.ERP_MATERIALS_RESPONSIBLE, PermissionEnum.ERP_MATERIALS_MANAGE, PermissionEnum.ERP_FLEET, PermissionEnum.ERP_JANITORIAL, PermissionEnum.ERP_ANIMALS, PermissionEnum.USER_DOCUMENTS, PermissionEnum.USER_TRAININGS, PermissionEnum.USER_CONDUCT_HISTORY, PermissionEnum.USER_ABSENCES, PermissionEnum.USER_CLOTHES, PermissionEnum.USER_DEPENDENTS, PermissionEnum.SKILLS_RESTRICTIONS, PermissionEnum.USER_PRIVATE_WEAPONS],
            "id": "management",
            "icon": "icon-sw-erp",
            "url": "#",
            "items": [
                {
                    "name": "Pessoal",
                    "permissions": [PermissionEnum.ERP_PERSONAL, PermissionEnum.USER_DOCUMENTS, PermissionEnum.USER_TRAININGS, PermissionEnum.USER_CONDUCT_HISTORY, PermissionEnum.USER_ABSENCES, PermissionEnum.USER_CLOTHES, PermissionEnum.USER_DEPENDENTS, PermissionEnum.SKILLS_RESTRICTIONS, PermissionEnum.USER_PRIVATE_WEAPONS],
                    "id": "personal",
                    "hide": false,
                    "url": "#",
                    "items": [
                        {
                            "name": "Agentes",
                            "permissions": [PermissionEnum.USER_DOCUMENTS, PermissionEnum.USER_TRAININGS, PermissionEnum.USER_CONDUCT_HISTORY, PermissionEnum.USER_ABSENCES, PermissionEnum.USER_CLOTHES, PermissionEnum.USER_DEPENDENTS, PermissionEnum.SKILLS_RESTRICTIONS, PermissionEnum.USER_PRIVATE_WEAPONS],
                            "id": "personal-agents",
                            "url": "personal-agents"
                        },
                        {
                            "name": "Escalas",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "id": "work-schedule",
                            "url": "work-schedule"
                        },
                        {
                            "name": "Equipes",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "id": "work-schedule-team",
                            "url": "team"
                        },
                        {
                            "name": "Feriados",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "id": "holiday",
                            "url": "holiday"
                        },
                        {
                            "name": "Jornadas",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "id": "work-schedule-journey",
                            "url": "journey"
                        },
                        {
                            "name": "Ausências",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "id": "work-schedule-absence",
                            "url": "absences"
                        },
                        {
                            "name": "Ensino",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "hide": true,
                            "id": "teaching",
                            "url": "#"
                        },
                        {
                            "name": "Disciplinar",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "hide": true,
                            "id": "disciplinary",
                            "url": "#"
                        },
                        {
                            "name": "Requerimentos",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "hide": true,
                            "id": "requirements",
                            "url": "#"
                        },
                        {
                            "name": "Assistencial",
                            "permissions": [PermissionEnum.ERP_PERSONAL],
                            "hide": true,
                            "id": "assistance",
                            "url": "#"
                        }
                    ]
                },
                {
                    "name": "Patrimônio",
                    "permissions": [PermissionEnum.ERP_ASSET],
                    "id": "asset",
                    "url": "#",
                    "items": [
                        {
                            "name": "Ativos",
                            "permissions": [PermissionEnum.ERP_ASSET],
                            "id": "assetActives",
                            "url": "asset-actives"
                        },
                        {
                            "name": "Locais",
                            "permissions": [PermissionEnum.ERP_ASSET],
                            "id": "assetPlaces",
                            "url": "asset-places"
                        },
                        {
                            "name": "Transferência entre locais",
                            "permissions": [PermissionEnum.ERP_ASSET],
                            "id": "assetTransfer",
                            "url": "asset-transfer"
                        }
                    ]
                },
                {
                    "name": "Materiais e meios",
                    "permissions": [PermissionEnum.ERP_MATERIALS_RESPONSIBLE, PermissionEnum.ERP_MATERIALS_MANAGE, PermissionEnum.ERP_MATERIALS_MANAGE2],
                    "id": "materials-general",
                    "url": "#",
                    "items": [
                        {
                            "name": "Home",
                            "id": "material-home",
                            "url": "materials/home",
                            "hideMenu": true
                        },
                        {
                            "name": "Guichê",
                            "permissions": [PermissionEnum.ERP_MATERIALS_RESPONSIBLE],
                            "id": "material-movements",
                            "url": "materials/movements"
                        },
                        {
                            "name": "Materiais em cautela",
                            "permissions": [PermissionEnum.ERP_MATERIALS_RESPONSIBLE],
                            "id": "material-cautions",
                            "url": "materials/cautions"
                        },
                        {
                            "name": "Baixas",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE2],
                            "id": "material-decreases",
                            "url": "materials/decreases"
                        },
                        {
                            "name": "Indisponibilidade de materiais",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE2],
                            "id": "material-maintenances",
                            "url": "materials/maintenances"
                        },
                        {
                            "name": "Aquisições",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE2],
                            "id": "material-registers",
                            "url": "materials/registers"
                        },
                        {
                            "name": "Transferências entre depósitos",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE2],
                            "id": "material-transfers",
                            "url": "materials/transfers"
                        },
                        {
                            "name": "Materiais por depósito",
                            "permissions": [PermissionEnum.ERP_MATERIALS_RESPONSIBLE],
                            "id": "material-x-storage",
                            "url": "materials/material-x-storage"
                        },
                        {
                            "name": "",
                            "permissions": "",
                            "id": "",
                            "url": "",
                            "horizontalRule": true
                        },
                        {
                            "name": "Grupos de materiais",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE],
                            "id": "material-groups",
                            "url": "materials/groups"
                        },
                        {
                            "name": "Materiais",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE],
                            "id": "materials",
                            "url": "materials"
                        },
                        {
                            "name": "Kits de materiais",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE],
                            "id": "material-kits",
                            "url": "materials/kits"
                        },
                        {
                            "name": "Depósitos",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE],
                            "id": "material-storages",
                            "url": "materials/storages"
                        },
                        {
                            "name": "Alertas",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE],
                            "id": "material-alerts",
                            "url": "materials/alerts"
                        },
                        {
                            "name": "Fornecedores",
                            "permissions": [PermissionEnum.ERP_MATERIALS_MANAGE],
                            "id": "material-suppliers",
                            "url": "materials/suppliers"
                        }
                    ]
                },
                {
                    "name": "Frota",
                    "permissions": [PermissionEnum.ERP_FLEET],
                    "id": "fleet",
                    "url": "#",
                    "items": [
                        {
                            "name": "Classes",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "vehicleClasses",
                            "url": "vehicle-classes"
                        },
                        {
                            "name": "Vistorias",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "inspection-items",
                            "url": "inspection-items"
                        },
                        {
                            "name": "Veículos",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "vehicles",
                            "url": "vehicles"
                        },
                        {
                            "name": "Registros de uso",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "usageRecords",
                            "url": "usage-record"
                        },
                        {
                            "name": "Itens de revisão",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "reviewItems",
                            "url": "review-items"
                        },
                        {
                            "name": "Abastecimentos",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "supplies",
                            "url": "supplies"
                        },
                        {
                            "name": "Manutenções",
                            "permissions": [PermissionEnum.ERP_FLEET],
                            "id": "maintenances",
                            "url": "maintenances"
                        }
                    ]
                },
                {
                    "name": "Zeladoria",
                    "permissions": [PermissionEnum.ERP_JANITORIAL],
                    "id": "janitorials",
                    "url": "#",
                    "items": [
                        {
                            "name": "Equipamentos",
                            "permissions": [PermissionEnum.ERP_JANITORIAL],
                            "id": "equipments",
                            "url": "equipments"
                        },
                        {
                            "name": "Solicitações",
                            "permissions": [PermissionEnum.ERP_JANITORIAL],
                            "id": "janitorial",
                            "url": "janitorial",
                            "homeName": "Solicitações de zeladoria"
                        }
                    ]
                },
                {
                    "name": "Animais",
                    "permissions": [PermissionEnum.ERP_ANIMALS],
                    "id": "animals",
                    "url": "#",
                    "items": [
                        {
                            "name": "Cadastro",
                            "permissions": [PermissionEnum.ERP_ANIMALS],
                            "id": "animal",
                            "url": "animals",
                            "homeName": "Animais - Cadastro"
                        }
                    ]
                }
            ]
        },
        {
            "name": "NOC",
            "id": "noc",
            "permissions": [PermissionEnum.NOC],
            "icon": FaVideo,
            "url": "#",
            "items": [
                {
                    "name": "Câmeras",
                    "permissions": [PermissionEnum.NOC],
                    "url": "noc-cameras",
                    "id": "noc-cameras",
                    "homeName": "NOC - Câmeras"
                },
                {
                    "name": "Smartcaptures",
                    "permissions": [PermissionEnum.NOC],
                    "url": "noc-smartcaptures",
                    "activeUrls": ["smartcaptures/form"],
                    "id": "noc-smartcaptures",
                    "homeName": "NOC - Smartcaptures"
                }
            ]
        },
        {
            "name": "Clones",
            "permissions": [PermissionEnum.SENTRY_CLONE],
            "icon": FaClone,
            "url": "clones",
            "id": "clones"
        },
        {
            "name": "Indivíduos",
            "permissions": [PermissionEnum.REFERENCE_INDIVIDUAL, PermissionEnum.INDIVIDUAL_MONITORING, PermissionEnum.INDIVIDUAL_ALARM],
            "url": "#",
            "icon": FaUser,
            "id": "individual-menu",
            "items": [
                {
                    "name": "Informações dos indivíduos",
                    "permissions": [PermissionEnum.REFERENCE_INDIVIDUAL],
                    "url": "individuals",
                    "id": "individual"
                },
                {
                    "name": "Pesquisa de passagens e reconhecimento facial",
                    "permissions": [PermissionEnum.INDIVIDUAL_PASSAGE_SEARCH],
                    "url": "individual-passage-search",
                    "id": "individual-passage-search",
                    "hideMenu": true
                },
                {
                    "name": "Alarmes",
                    "permissions": [PermissionEnum.INDIVIDUAL_ALARM],
                    "url": "individual-alarm",
                    "id": "individual-alarm",
                    "homeName": "Alarmes de indivíduos",
                    "hideMenu": true
                },
                {
                    "name": "Lista de monitoramento",
                    "permissions": [PermissionEnum.INDIVIDUAL_MONITORING],
                    "url": "individual-monitoring-watchlist",
                    "id": "individual-monitoring-watchlist"
                },
                {
                    "name": "Monitoramentos",
                    "permissions": [PermissionEnum.INDIVIDUAL_MONITORING],
                    "url": "individual-monitoring",
                    "id": "individual-monitoring",
                    "homeName": "Indivíduos - Monitoramentos"
                }
            ]
        },
        {
            "name": "Produtos perigosos",
            "permissions": [PermissionEnum.ADR_CODE, PermissionEnum.ADR_MONITORING],
            "icon": FaSkullCrossbones,
            "id": "adr",
            "url": "#",
            "items": [
                {
                    "name": "Monitoramentos",
                    "permissions": [PermissionEnum.ADR_MONITORING],
                    "url": "adr-monitoring",
                    "id": "adrMonitoring",
                    "homeName": "Produtos perigosos - Monitoramentos"
                },
                {
                    "name": "Painel de segurança",
                    "permissions": [PermissionEnum.ADR_CODE],
                    "url": "adr-code",
                    "id": "adrCode"
                }
            ]
        },
        {
            "name": "Veículos",
            "permissions": [PermissionEnum.REFERENCE_VEHICLE, PermissionEnum.REFERENCE_VEHICLES_NOTES, PermissionEnum.PASSAGE_LABEL, PermissionEnum.PASSAGE_SEARCH, PermissionEnum.PASSAGE_SEARCH_GEOREF, PermissionEnum.PASSAGE_SEARCH, PermissionEnum.PASSAGE_SEARCH_SENTRYCLOUD, PermissionEnum.CORTEX_PASSAGES],
            "url": "#",
            "icon": FaCar,
            "id": "vehicles-menu",
            "items": [
                {
                    "name": "Informações dos veículos",
                    "permissions": [PermissionEnum.REFERENCE_VEHICLE],
                    "url": "vehicle",
                    "id": "vehicle"
                },
                {
                    "name": "Pesquisa de passagens",
                    "permissions": [PermissionEnum.PASSAGE_SEARCH_GEOREF, PermissionEnum.PASSAGE_SEARCH, PermissionEnum.PASSAGE_SEARCH_SENTRYCLOUD, PermissionEnum.CORTEX_PASSAGES],
                    "url": "#",
                    "id": "vehicle-passages",
                    "items": [
                        {
                            "name": "Minha corporação",
                            "permissions": [PermissionEnum.PASSAGE_SEARCH],
                            "url": "corporation-search",
                            "id": "corporationSearch",
                            "homeName": "Pesquisa de passagens - Minha corporação",
                            "hideMenu": true
                        },
                        {
                            "name": "SentryCloud",
                            "permissions": [PermissionEnum.PASSAGE_SEARCH_SENTRYCLOUD],
                            "url": "sentry-cloud-search",
                            "id": "sentryCloudSearch",
                            "homeName": "Pesquisa de passagens - SentryCloud"
                        },
                        {
                            "name": "Córtex",
                            "permissions": [PermissionEnum.CORTEX_PASSAGES],
                            "url": "cortex-search",
                            "id": "cortexSearch",
                            "homeName": "Pesquisa de passagens - Córtex"
                        },
                        {
                            "name": "Mapa",
                            "permissions": [PermissionEnum.PASSAGE_SEARCH_GEOREF],
                            "url": "georeferencedSearch",
                            "id": "georeferencedSearch",
                            "homeName": "Pesquisa de passagens - Mapa"
                        }
                    ]
                },
                {
                    "name": "Marcadores de passagem",
                    "permissions": [PermissionEnum.PASSAGE_LABEL],
                    "url": "passage-labels",
                    "id": "passage-labels"
                },
                {
                    "name": "Anotações de veículos",
                    "permissions": [PermissionEnum.REFERENCE_VEHICLES_NOTES],
                    "url": "vehicle-notes",
                    "id": "vehicleNotes"
                },
                {
                    "name": "Validação de imagens",
                    "permissions": [PermissionEnum.PASSAGE_SEARCH],
                    "url": "image-validator",
                    "id": "imageValidator"
                }
            ]
        },
        {
            "name": "Convênios",
            "permissions": [PermissionEnum.CORTEX_RENAVAM, PermissionEnum.CELEPAR_RENAVAM, PermissionEnum.CELEPAR_DRIVER],
            "url": "#",
            "icon": FaCircleNodes,
            "id": "interconnection-menu",
            "items": [
                {
                    "name": "Córtex - RENAVAM",
                    "permissions": [PermissionEnum.CORTEX_RENAVAM],
                    "url": "cortex-renavam",
                    "id": "cortexRenavamSearch"
                },
                {
                    "name": "Celepar - RENAVAM",
                    "permissions": [PermissionEnum.CELEPAR_RENAVAM],
                    "url": "celepar-renavam",
                    "id": "celeparRenavamSearch"
                },
                {
                    "name": "Celepar - Condutor",
                    "permissions": [PermissionEnum.CELEPAR_DRIVER],
                    "url": "celepar-driver",
                    "id": "celeparDriverSearch"
                }
            ]
        },
        {
            "name": "Inteligência",
            "permissions": [PermissionEnum.ANALYSIS_NETWORK, PermissionEnum.ECAP, PermissionEnum.ECAP_TEMPLATE],
            "url": "#",
            "icon": FaMagnifyingGlassChart,
            "id": "intelligence",
            "items": [
                {
                    "name": "Rede de associação",
                    "permissions": [PermissionEnum.ANALYSIS_NETWORK],
                    "url": "association-network",
                    "id": "association-network"
                },
                {
                    "name": "Solicitações",
                    "permissions": [PermissionEnum.ECAP],
                    "url": "ecap-solicitation",
                    "id": "ecap-solicitation"
                },
                {
                    "name": "ECAP",
                    "permissions": [PermissionEnum.ECAP, PermissionEnum.ECAP_TEMPLATE],
                    "id": "ecap",
                    "url": "ecap"
                }
            ]
        },
        {
            "name": "Relatórios",
            "permissions": "sentry.report.*, sentry.reports.*",
            "icon": FaFileAlt,
            "url": "reports",
            "id": "reports"
        },
        {
            "name": "SOS Cidadão",
            "permissions": "sentry.sos.*",
            "id": "sos",
            "icon": FaShield,
            "url": "#",
            "items": [
                {
                    "name": "Home",
                    "permissions": [PermissionEnum.SOS_MANAGE_EVENTS, PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_PROTECTION_PROGRAM, PermissionEnum.SOS_CITIZEN_SCHEDULED_VISIT_MANAGE, PermissionEnum.REPORT_SOS_XRAY, PermissionEnum.REPORT_SOS_RECORDS, PermissionEnum.SOS_VIEW],
                    "id": "sos-home",
                    "url": "sos/home",
                    "hideMenu": true
                },
                {
                    "name": "SOS em aberto",
                    "permissions": [PermissionEnum.SOS_MANAGE_EVENTS],
                    "id": "sosOpen",
                    "url": "sos/event-open",
                    "activeUrls": ["sos/event-open"]
                },
                {
                    "name": "Histórico de SOS",
                    "permissions": [PermissionEnum.SOS_MANAGE_EVENTS],
                    "id": "sosFinalized",
                    "url": "sos/event-history"
                },
                {
                    "name": "Cadastros",
                    "permissions": [PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_VIEW],
                    "id": "citizenVerified",
                    "url": "sos/citizens"
                },
                {
                    "name": "Programa de proteção",
                    "permissions": [PermissionEnum.SOS_PROTECTION_PROGRAM],
                    "id": "sosProtectionProgram",
                    "url": "sos/protection-program"
                },
                {
                    "name": "Agressores",
                    "permissions": [PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_VIEW],
                    "id": "aggressors-list",
                    "url": "sos/aggressors-list"
                },
                {
                    "name": "Agendamento",
                    "permissions": [PermissionEnum.SOS_CITIZEN_SCHEDULED_VISIT_MANAGE],
                    "id": "citizen-scheduled-visit",
                    "url": "sos/citizen-scheduled-visit"
                },
                {
                    "name": "Dashboard SOS",
                    "permissions": [PermissionEnum.SOS_DASHBOARD],
                    "id": "dashboard-sos",
                    "url": "sos/dashboard-sos",
                    "hideMenu": true
                }
            ]
        },
        {
            "name": "Notificações",
            "permissions": "",
            "id": "notifications",
            "icon": FaPaperPlane,
            "url": "#",
            "items": [
                {
                    "name": "Em aberto",
                    "permissions": "",
                    "id": "notification-open",
                    "url": "notifications-open"
                },
                {
                    "name": "Assinadas",
                    "permissions": "",
                    "id": "notification-signed",
                    "url": "notifications-signed"
                },
                {
                    "name": "Visibilidade",
                    "permissions": [PermissionEnum.CONFIGURATION],
                    "id": "notifications-visibility",
                    "url": "notifications-visibility"
                }
            ]
        },
        {
            "name": "Contatos",
            "permissions": "sentry.*",
            "icon": FaAddressBook,
            "hide_dispatch": true,
            "id": "contacts",
            "url": "#",
            "items": [
                {
                    "name": "Corporações",
                    "permissions": "sentry.*",
                    "url": "shared-institutions",
                    "id": "sharedInstitutions"
                },
                {
                    "name": "Agentes",
                    "permissions": "sentry.*",
                    "url": "shared-agents",
                    "id": "sharedAgents"
                },
                {
                    "name": "Suporte técnico",
                    "permissions": "sentry.*",
                    "url": "contacts",
                    "id": "contacts",
                    "target": "_blank"
                }
            ]
        },
        {
            "name": "Dev",
            "permissions": "sentry.*",
            "icon": FaCode,
            "id": "dev",
            "url": "#",
            "hide_dispatch": true,
            "items": [
                {
                    "name": "Câmeras OCR e Integrações",
                    "url": "dev/ocr-cams-integration",
                    "permissions": "sentry.*",
                    "id": "ocrCamsIntegration"
                },
                {
                    "name": "Chaves Ativas",
                    "url": "dev/active-keys",
                    "permissions": "sentry.*",
                    "id": "activekeys"
                },
                {
                    "name": "Documentação",
                    "url": "dev/documentation",
                    "permissions": "sentry.*",
                    "id": "documentation"
                },
                {
                    "name": "Usuários de integração",
                    "url": "dev/integration-users",
                    "permissions": "sentry.*",
                    "id": "integration-users"
                },
                {
                    "name": "Formulários",
                    "url": "dev/form-builder",
                    "permissions": "sentry.*",
                    "id": "forms",
                    "hideMenu": true
                }
            ]
        }
    ]
};

export default SentryMenu;
